import { normalizeEmail, normalizeKey } from './text';

export const EXISTING_FAMILY = 'EXISTING_FAMILY';
export const EXISTING_FAMILY_MESSAGE =
  'This family already has a referral with the same family last name and parent/guardian email.';
export const POSSIBLY_RELATED_NOTICE =
  'A potentially related record may already exist. Admissions will review it.';

interface FamilyInput {
  familyLastName: string;
  guardians: readonly { firstName: string; lastName: string; email: string }[];
}

export interface GuardianOnFile {
  householdId: string;
  familyLastName: string;
  normalizedEmail: string | null;
  firstName: string;
  lastName: string;
}

export function existingFamilyKeys(
  p: Pick<FamilyInput, 'familyLastName' | 'guardians'>,
): { lastName: string; emails: string[] } | null {
  const lastName = normalizeKey(p.familyLastName);
  const emails = [...new Set(p.guardians.map((g) => normalizeEmail(g.email)).filter(Boolean))];
  return lastName && emails.length ? { lastName, emails } : null;
}

export function existingFamilyHouseholds(
  p: Pick<FamilyInput, 'familyLastName' | 'guardians'>,
  onFile: readonly Omit<GuardianOnFile, 'firstName' | 'lastName'>[],
): string[] {
  const keys = existingFamilyKeys(p);
  if (!keys) return [];
  const ids = onFile
    .filter(
      (g) =>
        !!g.normalizedEmail &&
        keys.emails.includes(g.normalizedEmail) &&
        normalizeKey(g.familyLastName) === keys.lastName,
    )
    .map((g) => g.householdId);
  return [...new Set(ids)];
}
